export class NonAisParent {
    relationship: string;
    email: string;
    family_name: string;
    given_name: string;
    phone: string
}


// WEBPACK FOOTER //
// ./src/common/modules/user/models/NonAisParent.ts